import React, { useState, useEffect , useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReorderModal from "./reorder/ReorderModal";

// import DayWiseItinerary from "./DayWiseItinerary";
import HoursItinerary from "./itinerary/HoursItinerary";
import OneDayItinerary from "./itinerary/OneDayItinerary";
import MultiDayItinerary from "./itinerary/MultiDayItinerary";
import { parseHoursText } from "../utils/parsers/parseHoursText";
import { parseOneDayText } from "../utils/parsers/parseOneDayText";
import { parseMultiDayText } from "../utils/parsers/parseMultiDayText";
import API_BASE_URL from "../services/apiClient";
import mockHotels from "../data/mockHotel";
import MiniLoader from "./MiniLoader";
import HotelCard from "./HotelCard";
const TextSkeleton = ({ lines = 6 }) => (
  <div className="space-y-3 py-6 w-full max-w-2xl mx-auto">
    {Array.from({ length: lines }).map((_, i) => (
      <div
        key={i}
        className={`bg-gray-100 rounded-lg animate-pulse ${i === 0 ? "h-7 w-1/3 mb-6" :
          i === 1 ? "h-3.5 w-full" :
            i === lines - 1 ? "h-3.5 w-2/3" : "h-3.5 w-full"
          }`}
      />
    ))}
  </div>
);


const TripResults = ({openLogin}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const city = location.state?.city;
  // const isDemo = location.state?.isDemo;
  // const demoReason = location.state?.reason;
  const tripType = location.state?.tripType || "multi";
  const [placeImages, setPlaceImages] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [qrTripId, setQrTripId] = useState(null);
const [qrLoading, setQrLoading] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false);
  const [startDate, setStartDate] = useState(
     location.state?.startDate ||null 
    ); // yyyy-mm-dd
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [pendingQRSave, setPendingQRSave] = useState(false);
  const [loginSuccessMessage, setLoginSuccessMessage] = useState(false);
const weatherFromState = location.state?.weather || null;
const tripDateFromState = location.state?.tripDate || null;

const [weather, setWeather] = useState(weatherFromState);
const [climate, setClimate] = useState(null);
const [climateLoading, setClimateLoading] = useState(false);
// const [showExitPopup, setShowExitPopup] = useState(false);
const [places360, setPlaces360] = useState([]);
const [selectedPlace, setSelectedPlace] = useState("");
// const [showSaveReminder, setShowSaveReminder] = useState(false);
const ENABLE_HOTELS = false;
const [isRedirecting, setIsRedirecting] = useState(false);

const extractPlacesFromItinerary = useCallback((data) => {
  if (!data?.days) return [];

  const places = [];

  data.days.forEach((day, i) => {
    (day.sections || []).forEach(section => {
      (section.activities || []).forEach(act => {
        if (act.location) {
          places.push({
            label: `Day ${i + 1}`,
            place: `${act.location}, ${city}`
          });
        }
      });
    });
  });

  return places.slice(0, 9);
}, [city]);



// useEffect(() => {
//   if (qrTripId) return; // if saved → no reminder

//   const timer = setTimeout(() => {
//     setShowSaveReminder(true);
//   }, 40000); // 30 seconds

//   return () => clearTimeout(timer);
// }, [qrTripId]);



  const fetchPlaceImages = async (place, osmAttractions = []) => {
    const queries = [
      `${place} city`,
      `${place} skyline`,
      `${place} landmarks`,
      `${place} tourism`,
      `${place} travel`,
    ];

    const isGoodImage = (img) => {
      const text =
        `${img.alt_description || ""} ${img.description || ""}`.toLowerCase();

      const banned = [
        "person",
        "people",
        "portrait",
        "model",
        "food",
        "dish",
        "drink",
        "selfie",
        "face",
      ];

      if (banned.some((w) => text.includes(w))) return false;

      return (
        text.includes(place.toLowerCase()) ||
        text.includes("city") ||
        text.includes("street") ||
        text.includes("landscape")
      );
    };

    const search = async (q) => {
      const res = await fetch(
        `https://api.unsplash.com/search/photos?query=${encodeURIComponent(
          q
        )}&per_page=9&orientation=landscape&content_filter=high`,
        {
          headers: {
            Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_KEY}`,
          },
        }
      );

      if (!res.ok) return [];

      const data = await res.json();
      if (!data.results) return [];

      return data.results.filter(isGoodImage);
    };

    // 1️⃣ Try city queries
    for (const q of queries) {
      const imgs = await search(q);
      if (imgs.length >= 3) return imgs.slice(0, 6);
    }

    // 2️⃣ Try OSM attraction names
    for (const a of osmAttractions) {
      const imgs = await search(`${a.name} ${place}`);
      if (imgs.length >= 3) return imgs.slice(0, 6);
    }

    // 3️⃣ Fail cleanly
    return [];
  };

 



  



  /* ================= GET DATA SAFELY ================= */
  const suggestions =
    location.state?.suggestions ||
JSON.parse(localStorage.getItem("lastTripResult") || "null");



  const [buildingDays, setBuildingDays] = useState(false);


  const [isTyping, setIsTyping] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [finalText, setFinalText] = useState("");
  const [isEditing, setIsEditing] = useState(false);


  const [guide, setGuide] = useState(null);

  const [cityInfo, setCityInfo] = useState(null);
  const [cityLoading, setCityLoading] = useState(false);
  const [osmData, setOsmData] = useState(null);
  // const [osmLoading, setOsmLoading] = useState(false);
  const [osmError, setOsmError] = useState("");

  const viewMode = "days";// text | json|Days
  const [jsonData, setJsonData] = useState(null);
  const [costEstimate, setCostEstimate] = useState(null);
  const [showReorderModal, setShowReorderModal] = useState(false);
  const [tempDays, setTempDays] = useState([]);
  useEffect(() => {
    if (showReorderModal && jsonData?.days?.length) {
      setTempDays(
        jsonData.days.map((day, index) => ({
          ...day,
          _id: `day-${index}`,     // required by dnd-kit
          displayDay: index + 1,   // for UI label
        }))
      );
    }
  }, [showReorderModal, jsonData]);



  const [jsonError, setJsonError] = useState("");
  const [savingOrder, setSavingOrder] = useState(false);

useEffect(() => {
  if (!jsonData || !city) return;

  const fetchCost = async () => {
    try {
const res = await fetch(`${API_BASE_URL}/api/cost/estimate`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    city,
    tripType,
    days: jsonData?.days?.length,
    startDate
  }),
});

if (!res.ok) {
  const text = await res.text();
  console.error("Cost API error:", text);
  return;
}



const data = await res.json();
setCostEstimate(data);
    } catch (err) {
      console.error("Cost estimation failed", err);
    }
  };

  fetchCost();
}, [jsonData, city, tripType, startDate]);

  useEffect(() => {
    if (!city) return;

    setImageLoading(true);

    fetchPlaceImages(city, osmData?.attractions || [])
      .then((imgs) => setPlaceImages(imgs))
      .catch(() => setPlaceImages([]))
      .finally(() => setImageLoading(false));

  }, [city, osmData]);







  const handleExportToGoogleCalendar = () => {
    if (!startDate || !jsonData?.days?.length) {
      alert("Please select a start date first");
      return;
    }

    const urls = buildGoogleCalendarUrl({
      startDate,
      days: jsonData.days.length,
      city,
      tripType, // 🔥 IMPORTANT
    });

    urls.forEach((url) => window.open(url, "_blank"));
  };
 const parseByTripType = useCallback(
  (text) => {
    if (!text) return null;

    try {
      if (tripType === "hours") return parseHoursText(text);
      if (tripType === "day") return parseOneDayText(text);
      return parseMultiDayText(text);
    } catch (err) {
      console.error("Parsing failed:", err);
      return null;
    }
  },
  [tripType]
);

  useEffect(() => {
    if (!finalText) return;

    setBuildingDays(true);

    const timer = setTimeout(() => {
      try {
        const parsed = parseByTripType(finalText);
        setJsonData(parsed);
        setJsonError("");
      } catch (e) {
        console.error(e);
        setJsonError("Failed to parse itinerary");
        setJsonData(null);
      } finally {
        setBuildingDays(false);
      }
    }, 300); // 👈 small delay so spinner renders

    return () => clearTimeout(timer);
  }, [finalText, parseByTripType]);




 

  /* ================= HARD REDIRECT IF NOTHING ================= */
  useEffect(() => {
    if (!suggestions) {
      navigate("/", { replace: true });
    }
  }, [suggestions, navigate]);

  useEffect(() => {
    if (!city) return;

    const fetchGuide = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/guides?city=${encodeURIComponent(city)}`
        );

        if (!res.ok) throw new Error("Guide fetch failed");

        const data = await res.json();

        setGuide(data.available ? data.guide : null);
      } catch (err) {
        console.error("Failed to fetch guide:", err);
        setGuide(null);
      }
    };

    fetchGuide();
  }, [city]);

useEffect(() => {
  if (!city) return;

  const fetchWeatherAndClimate = async () => {
    try {
      setClimateLoading(true);

      // Always fetch climate
      const climateRes = await fetch(
        `${API_BASE_URL}/api/climate?city=${encodeURIComponent(city)}`
      );

 if (climateRes.ok) {
  try {
    const climateData = await climateRes.json();
    setClimate(climateData);
  } catch {
    console.error("Climate API returned invalid JSON");
  }
}

      // 🔥 Only fetch weather if NOT already passed from form
      if (!weatherFromState) {
        const weatherRes = await fetch(
          `${API_BASE_URL}/api/weather?city=${encodeURIComponent(city)}`
        );

        if (weatherRes.ok) {
          const weatherData = await weatherRes.json();
          setWeather(weatherData);
        }
      }

    } catch (err) {
      console.error("Weather/Climate fetch error:", err);
    } finally {
      setClimateLoading(false);
    }
  };

  fetchWeatherAndClimate();

}, [city, weatherFromState]);



  useEffect(() => {
    if (!city) return;

    const fetchCityData = async () => {
      setCityLoading(true);
      // setOsmLoading(true);

      setOsmError("");

      try {
        const [wikiRes, osmRes] = await Promise.allSettled([
          fetch(
            `${API_BASE_URL}/api/wiki?query=${encodeURIComponent(city)}`
          ).then(r => r.json()),

          fetch(
            `${API_BASE_URL}/api/osm?city=${encodeURIComponent(city)}`
          ).then(r => r.json()),
        ]);

        // ✅ WIKI (independent)
        if (
          wikiRes.status === "fulfilled" &&
          wikiRes.value?.available
        ) {
          setCityInfo(wikiRes.value);
        }

        // ✅ OSM (independent)
        if (
          osmRes.status === "fulfilled" &&
          osmRes.value?.available &&
          osmRes.value?.attractions?.length > 0
        ) {
          setOsmData(osmRes.value);
        }
      } catch (err) {
        console.error("City data load failed", err);
        setOsmError("Attractions service temporarily unavailable");
      } finally {
        setCityLoading(false);
        // setOsmLoading(false);
      }
    };

    fetchCityData();
  }, [city]);







  const buildGoogleCalendarUrl = ({
    startDate,
    days,
    city,
    tripType,
  }) => {
    const base =
      "https://calendar.google.com/calendar/render?action=TEMPLATE";

    const events = [];

    // 🔹 Title logic
    const title =
      tripType === "day"
        ? `${city} One Day Trip`
        : `${city} ${days} Days Trip`;

    // 🔹 One-day → ONE event
    if (tripType === "day") {
      const date = new Date(startDate);
      const start = date.toISOString().slice(0, 10).replace(/-/g, "");

      events.push(
        `${base}` +
        `&text=${encodeURIComponent(title)}` +
        `&dates=${start}/${start}` +
        `&details=${encodeURIComponent(`Travel itinerary for ${city}`)}` +
        `&location=${encodeURIComponent(city)}`
      );

      return events;
    }

    // 🔹 Multi-day → ONE event per day (same title)
    for (let i = 0; i < days; i++) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + i);

      const start = date.toISOString().slice(0, 10).replace(/-/g, "");

      events.push(
        `${base}` +
        `&text=${encodeURIComponent(title)}` +
        `&dates=${start}/${start}` +
        `&details=${encodeURIComponent(`Travel itinerary for ${city}`)}` +
        `&location=${encodeURIComponent(city)}`
      );
    }

    return events;
  };



  /* ================= TYPE EFFECT ================= */
 useEffect(() => {
  if (!suggestions?.text || finalText) return;


    setIsTyping(true);
    setFinalText("");
    setDisplayText("");
    setIsEditing(false);

    const lines = suggestions.text.split("\n");
    let index = 0;

    const typingInterval = setInterval(() => {
      index++;
      setDisplayText(lines.slice(0, index).join("\n"));

      if (index >= lines.length) {
        clearInterval(typingInterval);
        setFinalText(suggestions.text);
        setDisplayText("");
        setIsTyping(false);
      }
    }, 220 + Math.random() * 80);

    return () => clearInterval(typingInterval);
  }, [suggestions , finalText]);

const saveTrip = useCallback(
async (token) => {

if (!finalText) return;

if (!jsonData || !jsonData.days || jsonData.days.length === 0) {
  alert("Trip not ready yet");
  return;
}

try {

setQrLoading(true);

const res = await fetch(
`${API_BASE_URL}/api/trips`,
{
method: "POST",
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${token}`,
},
body: JSON.stringify({
  itinerary: jsonData,
  rawText: finalText,
  cityName: city,
  tripType,
  startDate,
  endDate: null,

  // 🔧 REQUIRED FOR COST ENGINE
  days: jsonData?.days?.length || 1,
  group: 1,
  activities: [],
})
}
);

let data;

try {
  data = await res.json();
} catch (err) {
  const text = await res.text();
  console.error("Trip save returned non-JSON:", text);
  throw new Error("Server returned invalid response");
}

if (!res.ok) {
  throw new Error(data?.message || "Trip save failed");
}

setQrTripId(data.shareToken);




setLoginSuccessMessage(true);

setTimeout(() => {
setLoginSuccessMessage(false);
}, 4000);

setIsRedirecting(true);

setTimeout(() => {
  navigate(`/trip/${data.travelKeyToken}`);
}, 1200);

} catch (err) {
console.error("Trip save failed:", err);
} finally {
setQrLoading(false);
}

},
[finalText, jsonData, city, tripType, startDate, navigate]
);

 useEffect(() => {
  if (!pendingQRSave) return;

  const interval = setInterval(() => {
    const token =
      sessionStorage.getItem("token") ||
      localStorage.getItem("token");

    if (token) {
      clearInterval(interval);
      setPendingQRSave(false);
      setShowLoginPrompt(false);
      saveTrip(token);   // ✅ Correct function
    }
  }, 500);

  return () => clearInterval(interval);
}, [pendingQRSave, saveTrip]);   // ✅ FIXED HERE

  /* ================= QR ================= */
 /* ================= SAVE & SHARE ================= */
const handleGenerateQR = async () => {
  const token =
    sessionStorage.getItem("token") ||
    localStorage.getItem("token");

  // 🔐 Not logged in → show login modal
  if (!token) {
    setPendingQRSave(true);
    setShowLoginPrompt(true);
    return;
  }

  await saveTrip(token);   // ✅ Uses new Trip system
};


useEffect(() => {
  if (!jsonData) return;

  const extracted = extractPlacesFromItinerary(jsonData);

  setPlaces360(extracted);

  if (extracted.length > 0) {
    setSelectedPlace(extracted[0].place);
  }
}, [jsonData , extractPlacesFromItinerary]);



  /* ================= LOADING SCREEN ================= */


  const AttractionSection = ({ title, items }) => {
    if (!items || items.length === 0) return null;

    return (
      <div className="space-y-6">
        <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">{title}</h3>
        <div className="grid gap-0 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((place) => (
            <div key={place.id} className="group">
              <div className="flex items-center gap-3 py-3.5 border-b border-gray-100 group-hover:border-gray-200 transition-colors px-1">
                <div className="w-7 h-7 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center text-sm flex-shrink-0 group-hover:bg-[#5b6f00]/10 group-hover:border-[#5b6f00]/20 transition-colors">
                  📍
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-gray-800 truncate">{place.name}</div>
                  {place.mapsLink && (
                    <a
                      href={place.mapsLink}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-[#5b6f00] transition-colors mt-0.5"
                    >
                      <span>View map</span>
                      <span className="group-hover:translate-x-0.5 transition-transform">→</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };


  const heroImage =
    placeImages.length > 0
      ? placeImages[0].urls.regular
      : cityInfo?.image || null;


  /* ================= RESULT ================= */
  return (
    <div className="min-h-screen bg-[#fafaf9] text-gray-900 font-sans selection:bg-[#5b6f00]/10 selection:text-[#5b6f00] pb-32">

      {/* ================= HERO HEADER ================= */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-5 sm:pt-8 pb-8 sm:pb-14">

        {/* Back Button - Minimal */}
        <button
          onClick={() => {
 
  navigate(-1);
}}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-400 hover:text-gray-700 transition-colors group py-2 mb-6"
        >
          <span className="group-hover:-translate-x-0.5 transition-transform text-base">←</span>
          <span>Back</span>
        </button>

        {/* Hero Layout: Text + Primary CTA */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 sm:gap-8">
          {/* Left: copy */}
          <div className="space-y-4 animate-fade-in">

  {/* TAG */}
  <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#5b6f00]/10 rounded-full">
    <span className="w-1.5 h-1.5 bg-[#5b6f00] rounded-full"></span>
    <span className="text-[10px] sm:text-xs font-bold tracking-widest uppercase text-[#5b6f00]">
      AI Travel Planner
    </span>
  </div>

  {/* HEADING */}
<h1 className="text-5xl sm:text-7xl lg:text-8xl font-bold tracking-tight text-gray-900 leading-none">
    <span className="text-[#00000]">
      {city || "Trip"}
    </span>
  </h1>

  {/* SUBTEXT */}
  <p className="text-base sm:text-lg text-gray-500 max-w-xl leading-relaxed">
    Smart itinerary, budget tracking, and collaboration — all in one place.
  </p>

</div>

          {/* Right: Hero CTA (desktop only) */}
          {!qrTripId && (
            <div className="hidden lg:flex flex-col items-end gap-3 shrink-0">
              <button
                onClick={() => document.getElementById("qr-section")?.scrollIntoView({ behavior: "smooth" })}
                className="bg-[#5b6f00] text-white px-8 py-4 rounded-2xl font-bold text-base hover:bg-[#4a5a00] hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#5b6f00]/25 active:scale-[0.98] transition-all flex items-center gap-2.5 group shadow-md"
              >
                <span>Save your trip</span>
                <span className="group-hover:translate-x-0.5 transition-transform border-l border-white/20 pl-2.5">→</span>
              </button>
              <p className="text-xs text-gray-400 font-medium">🔒 Securely saved to your account</p>
            </div>
          )}
        </div>

        {/* Progress Checklist */}
        <div className="mt-6 sm:mt-8 flex flex-wrap gap-2 sm:gap-3">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-gray-100 rounded-full text-xs font-semibold text-gray-600 shadow-sm">
            <span className="text-[#5b6f00]">✔</span> Itinerary ready
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-gray-100 rounded-full text-xs font-semibold text-gray-600 shadow-sm">
            <span className="text-[#5b6f00]">✔</span> Travel insights
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-gray-100 rounded-full text-xs font-semibold text-gray-400 shadow-sm">
            <span className="text-gray-300">⬜</span> Save trip
          </span>
        </div>

        {/* Mobile Hero CTA */}
        {!qrTripId && (
          <button
            onClick={() => document.getElementById("qr-section")?.scrollIntoView({ behavior: "smooth" })}
            className="lg:hidden mt-5 w-full bg-[#5b6f00] text-white py-4 rounded-2xl font-bold text-base hover:bg-[#4a5a00] active:scale-[0.98] transition-all flex items-center justify-center gap-2.5 group shadow-md"
          >
            <span>Save your trip</span>
            <span className="group-hover:translate-x-0.5 transition-transform border-l border-white/20 pl-2.5">→</span>
          </button>
        )}

        {/* ================= IMAGES + INFO LAYOUT ================= */}
        {city && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-6 mt-8 sm:mt-12">

            {/* Main Image - Full Width on Mobile, 2/3 on Desktop */}
            <div className="lg:col-span-2">
              <div className="rounded-2xl overflow-hidden bg-gray-100 min-h-[260px] sm:min-h-[380px] relative group border border-gray-100">
                {imageLoading ? (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="w-7 h-7 border-2 border-gray-200 border-t-gray-500 rounded-full animate-spin" />
                      <span className="text-xs text-gray-400">Loading images...</span>
                    </div>
                  </div>
                ) : heroImage ? (
                  placeImages.length > 0 ? (
                    <div className="grid grid-cols-3 grid-rows-2 gap-1.5 h-[260px] sm:h-[440px] p-1.5">
                      <img
                        src={heroImage}
                        className="col-span-2 row-span-2 w-full h-full object-cover rounded-xl transition-transform duration-700 group-hover:scale-[1.015]"
                        alt={city}
                      />
                      {placeImages.slice(1, 3).map((img, i) => (
                        <img
                          key={i}
                          src={img.urls.regular}
                          className="w-full h-full object-cover rounded-xl transition-transform duration-700 group-hover:scale-[1.015]"
                          alt={city}
                        />
                      ))}
                    </div>
                  ) : (
                    <img
                      src={heroImage}
                      className="w-full h-[260px] sm:h-[440px] object-cover transition-transform duration-700 group-hover:scale-[1.015]"
                      alt={city}
                    />
                  )
                ) : (
                  <div className="h-[260px] sm:h-[440px] flex flex-col items-center justify-center text-gray-200">
                    <span className="text-5xl mb-3">📸</span>
                    <p className="text-sm text-gray-400">No images available</p>
                  </div>
                )}
              </div>
            </div>

            {/* Sidebar - Info & Guide */}
            <div className="lg:col-span-1 flex flex-col gap-5">

              {/* City Info Card */}
              {cityLoading ? (
                <div className="h-48 bg-gray-100 rounded-2xl animate-pulse" />
              ) : cityInfo ? (
                <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4">
                  <h2 className="text-xs font-bold uppercase tracking-wider text-gray-400">
                    About {city}
                  </h2>
                  <p className="text-sm leading-relaxed text-gray-600">
                    {cityInfo.description}
                  </p>
                  {cityInfo.wikipediaUrl && (
                    <a
                      href={cityInfo.wikipediaUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-700 hover:text-[#5b6f00] transition-colors group"
                    >
                      <span>Learn more</span>
                      <span className="group-hover:translate-x-0.5 transition-transform">→</span>
                    </a>
                  )}
                </div>
              ) : null}

              {/* Local Guide Card */}
              {guide && (
                <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-green-500 rounded-full flex items-center justify-center text-xl flex-shrink-0">
                      👋
                    </div>
                    <div>
                      <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400">Local Expert</p>
                      <p className="text-sm font-bold text-gray-900">{guide.name}</p>
                    </div>
                  </div>
                  <a
                    href={`https://wa.me/${guide.phone}`}
                    target="_blank"
                    rel="noreferrer"
                    className="block w-full text-center bg-gray-900 text-white font-semibold py-2.5 rounded-xl text-sm hover:bg-gray-800 active:scale-[0.98] transition-all"
                  >
                    Start Conversation
                  </a>
                </div>
              )}
            </div>
          </div>
        )}

      </div>

 {climateLoading ? (
  <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
    <div className="h-28 bg-gray-100 rounded-2xl animate-pulse" />
  </div>
) : (weather || climate) && (
  <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">

    <div className="grid sm:grid-cols-2 gap-4">

      {/* 🌦 Weather Card */}
      {weather && (
        <div className="bg-white rounded-2xl border border-gray-100 p-5 flex items-center gap-5 hover:shadow-sm hover:-translate-y-px transition-all">
          <div className="w-12 h-12 rounded-xl bg-sky-50 border border-sky-100 flex items-center justify-center text-2xl flex-shrink-0">
            🌤
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400 mb-0.5">
              {tripDateFromState ? `Weather · ${tripDateFromState}` : "Current Weather"}
            </p>
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-bold text-gray-900">{weather.temperature}°C</span>
              <span className="text-sm text-gray-500">{weather.condition}</span>
            </div>
            <p className="text-xs text-gray-400 mt-1">Wind: {weather.windSpeed} km/h</p>
          </div>
        </div>
      )}

      {/* 🌤 Climate Card */}
      {climate && (
        <div className="bg-white rounded-2xl border border-gray-100 p-5 flex items-center gap-5 hover:shadow-sm hover:-translate-y-px transition-all">
          <div className="w-12 h-12 rounded-xl bg-[#5b6f00]/8 border border-[#5b6f00]/15 flex items-center justify-center text-2xl flex-shrink-0">
            🗓
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400 mb-0.5">Best Time to Visit</p>
            <div className="text-base font-bold text-gray-900">{climate.bestTimeRange}</div>
            <p className="text-xs text-gray-500 mt-0.5 leading-snug line-clamp-2">{climate.explanation}</p>
          </div>
          <div className="text-right shrink-0">
            <div className="text-xl font-bold text-[#5b6f00]">{climate.travelComfortIndex}</div>
            <div className="text-[10px] text-gray-400">/ 100</div>
          </div>
        </div>
      )}

    </div>
  </div>
)}



      {/* ================= ITINERARY SECTION ================= */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 sm:mt-14">

        {/* Section Header */}
        <div className="mb-6 sm:mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">Step by step</p>
              <h2 className="text-2xl sm:text-4xl font-bold text-gray-900 tracking-tight">
                Your Itinerary
              </h2>
            </div>

            {/* Compact Actions Row */}
            <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
              <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl px-3 py-2">
                <span className="text-xs text-gray-400 font-medium hidden sm:inline">Start</span>
                <input
                  type="date"
                  value={startDate || ""}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="text-sm font-medium text-gray-900 bg-transparent focus:outline-none cursor-pointer"
                />
              </div>

              <button
                onClick={() => setShowReorderModal(true)}
                className="p-2.5 bg-white border border-gray-200 hover:border-gray-300 rounded-xl text-gray-400 hover:text-gray-700 transition-all hover:-translate-y-px"
                title="Reorder Days"
              >
                <span className="text-base">⚙️</span>
              </button>

              <button
                onClick={handleExportToGoogleCalendar}
                disabled={!startDate}
                className={`flex items-center gap-1.5 text-sm px-4 py-2.5 rounded-xl font-semibold border transition-all hover:-translate-y-px ${
                  !startDate
                    ? "text-gray-300 border-gray-100 cursor-not-allowed bg-white"
                    : "text-gray-700 border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm"
                }`}
              >
                <span>📆</span>
                <span>Export</span>
              </button>
            </div>
          </div>
        </div>

        {/* Content Area - No Heavy Box */}
        <div className="min-h-[500px]">

          {/* Typewriter Effect */}
          {isTyping && (
            <div className="py-12">
              <div className="whitespace-pre-wrap font-mono text-sm text-gray-500 leading-relaxed">
                {displayText}<span className="animate-pulse">|</span>
              </div>
            </div>
          )}

          {/* Text Mode */}
          {!isTyping && viewMode === "text" && (
            <div className="py-8">
              {isEditing ? (
                <div className="space-y-6">
                  <textarea
                    value={finalText}
                    onChange={(e) => setFinalText(e.target.value)}
                    className="w-full h-[600px] p-6 font-mono text-sm bg-white border border-gray-200 rounded-2xl focus:ring-2 focus:ring-gray-900 focus:border-transparent outline-none resize-none"
                  />
                  <div className="flex justify-end">
                    <button
                      onClick={() => setIsEditing(false)}
                      className="bg-gray-900 text-white px-8 py-3 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors"
                    >
                      Done Editing
                    </button>
                  </div>
                </div>
              ) : (
                <div className="space-y-6">
                  <div className="prose prose-lg max-w-none text-gray-700 whitespace-pre-wrap leading-relaxed">
                    {finalText || <TextSkeleton />}
                  </div>

                  <button
                    onClick={() => setIsEditing(true)}
                    className="text-sm text-gray-400 hover:text-gray-900 transition-colors"
                  >
                    Edit text →
                  </button>
                </div>
              )}
            </div>
          )}

          {/* JSON Mode */}
          {!isTyping && viewMode === "json" && (
            <div className="py-8">
              <div className="relative">
                {jsonError && (
                  <div className="absolute top-4 right-4 bg-red-50 text-red-600 text-xs px-3 py-2 rounded-lg">
                    Parse error
                  </div>
                )}
                <pre className="bg-gray-900 text-gray-300 p-8 rounded-2xl overflow-auto text-xs font-mono max-h-[700px] leading-relaxed">
                  {JSON.stringify(jsonData, null, 2)}
                </pre>
              </div>
            </div>
          )}

          {/* Timeline Mode - The Star */}
          {!isTyping && viewMode === "days" && (
            <div className="py-8">
              {buildingDays ? (
                <div className="flex flex-col items-center justify-center py-32 space-y-6">
                  <div className="w-16 h-16 border-4 border-gray-900 border-t-transparent rounded-full animate-spin" />
                  <p className="text-gray-400 font-medium">Building your timeline...</p>
                </div>
              ) : (
                <>
                  {/* HOURS TRIP */}
                  {tripType === "hours" && (
                    <HoursItinerary
                      data={jsonData}
                      city={city}
                      costEstimate={costEstimate}
                    />
                  )}

                  {/* ONE DAY TRIP */}
                  {tripType === "day" && (
                    <OneDayItinerary
                      data={jsonData}
                      city={city}
                      startDate={startDate}
                      costEstimate={costEstimate}
                    />
                  )}

                  {/* MULTI DAY TRIP */}
                  {tripType === "multi" && jsonData?.days?.length > 0 && (
                    <MultiDayItinerary
                      data={jsonData}
                      city={city}
                      startDate={startDate}
                      costEstimate={costEstimate}
                    />
                  )}

                  {/* Inline CTA */}
                  {/* {!qrTripId && (
                    <div className="mt-10 sm:mt-16 flex justify-center">
                      <button
                        onClick={() => document.getElementById("qr-section")?.scrollIntoView({ behavior: "smooth" })}
                        className="bg-white border border-gray-200 text-gray-900 px-6 sm:px-8 py-4 rounded-2xl font-semibold hover:bg-[#5b6f00] hover:text-white hover:border-[#5b6f00] sm:hover:-translate-y-1 sm:hover:shadow-lg sm:hover:shadow-[#5b6f00]/20 active:scale-[0.98] transition-all flex items-center justify-center gap-3 w-full sm:w-auto group shadow-sm"
                      >
                        Continue planning your trip
                        <span className="group-hover:translate-x-1 transition-transform border-l pl-3 ml-1 border-gray-200 group-hover:border-white/20">→</span>
                      </button>
                    </div>
                  )} */}
                </>
              )}
            </div>
          )}

        </div>
      </div>
      {/* ================= HOTEL SECTION ================= */}
{ENABLE_HOTELS &&(
<div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
  
  <div className="mb-8">
    <h2 className="text-3xl font-bold text-gray-900">
      Recommended Stay
    </h2>
    <p className="text-gray-500 mt-2">
      Flexible stays powered by Nappr
    </p>
  </div>

   <div className="flex gap-4 overflow-x-auto pb-2">
    {mockHotels?.length > 0 ? (
      mockHotels.map((hotel) => (
        <HotelCard
          key={hotel.id}
          hotel={hotel}
          city={city}
          startDate={startDate}
        />
      ))
    ) : (
      <p className="text-gray-400 text-sm">No stays found</p>
    )}
  </div>

</div>
)}
      {loginSuccessMessage && (
        <div className="fixed top-6 right-6 bg-green-600 text-white px-6 py-3 rounded-xl shadow-lg animate-fade-in z-50">
          ✅ Your trip has been saved to your profile
        </div>
      )}

{!qrTripId && (
  <div className="relative max-w-4xl mx-auto mt-10 sm:mt-14 px-4">

    {/* 🔒 CLICKABLE PREVIEW WRAPPER */}
    <div
      onClick={() => {
        document.getElementById("qr-section")?.scrollIntoView({ behavior: "smooth" });
      }}
      className="relative cursor-pointer group rounded-2xl"
    >

{/* 🔥 SOFT BLUR OVERLAY */}
<div className="absolute inset-0 bg-white/10 backdrop-blur-[1px] sm:backdrop-blur-[2px] rounded-2xl z-10 pointer-events-none transition-all duration-300" />

{/* 🔒 CENTER LOCK (ABOVE BLUR) */}
<div className="absolute inset-0 z-20 flex flex-col items-center justify-center pointer-events-none gap-2 px-4">
  <div className="w-14 h-14 sm:w-20 sm:h-20 rounded-2xl bg-white/95 flex items-center justify-center text-xl sm:text-2xl shadow-lg border border-gray-100 transition-transform duration-200 group-active:scale-95 group-hover:scale-105">
    🔒
  </div>
  <span className="text-xs font-bold text-gray-700 bg-white/95 px-4 py-1.5 rounded-full shadow-sm border border-gray-100 mt-1">
    Save to unlock
  </span>
</div>

{/* 🧠 DASHBOARD PREVIEW */}
<div className="bg-white rounded-2xl border border-gray-100 p-5 sm:p-7 space-y-4 transition-all duration-300 group-hover:shadow-md">
        {/* HEADER */}
        <div className="flex justify-between items-center border-b border-gray-50 pb-3">
          <h3 className="text-base sm:text-lg font-bold text-gray-900 flex items-center gap-2">
            <span className="w-7 h-7 rounded-lg bg-gray-50 border border-gray-100 flex items-center justify-center text-sm">⛺</span>
            Trip Command Center
          </h3>
          <span className="text-[10px] font-bold uppercase tracking-wider bg-[#5b6f00]/10 text-[#5b6f00] px-2.5 py-1 rounded-lg">
            Click to unlock
          </span>
        </div>

        {/* CARDS */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">

          {/* 💰 Budget */}
          <div className="border border-gray-100 rounded-xl p-4 flex flex-col gap-2.5 bg-gray-50/40">
            <div className="flex items-center gap-2 text-gray-900 font-semibold text-sm">
              <span>💰</span> Track Budget
            </div>
            <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full w-2/5 bg-[#5b6f00] rounded-full"></div>
            </div>
            <p className="text-xs text-gray-400">Manage your travel expenses</p>
          </div>

          {/* 📄 Tickets */}
          <div className="border border-gray-100 rounded-xl p-4 flex flex-col gap-2.5 bg-gray-50/40">
            <div className="flex items-center gap-2 text-gray-900 font-semibold text-sm">
              <span>📄</span> Store Tickets
            </div>
            <div className="w-full h-8 bg-white rounded-lg border border-dashed border-gray-200 flex items-center justify-center">
              <span className="text-gray-300 text-xs font-medium">+ Add Pass</span>
            </div>
            <p className="text-xs text-gray-400">Keep flights & hotels handy</p>
          </div>

          {/* 👥 Collaboration */}
          <div className="border border-gray-100 rounded-xl p-4 flex flex-col gap-2.5 bg-gray-50/40">
            <div className="flex items-center gap-2 text-gray-900 font-semibold text-sm">
              <span>👥</span> Collaborate
            </div>
            <div className="flex -space-x-2">
              <div className="w-7 h-7 rounded-full bg-gray-300 border-2 border-white"></div>
              <div className="w-7 h-7 rounded-full bg-gray-400 border-2 border-white"></div>
              <div className="w-7 h-7 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-[10px] font-bold text-gray-600">+2</div>
            </div>
            <p className="text-xs text-gray-400">Invite friends to plan together</p>
          </div>

        </div>
      </div>
    </div>
  </div>
)}

      {/* ================= SAVE TRIP ================= */}
 <div
  id="qr-section"
  className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-14 sm:mt-20 pb-10"
>
  <div className="bg-white rounded-2xl p-6 sm:p-10 border border-gray-100 shadow-sm relative overflow-hidden">

    {/* Subtle accent */}
    <div className="absolute top-0 right-0 w-48 h-48 bg-[#5b6f00]/5 rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none"></div>

    {/* Header */}
    <div className="text-center space-y-3 mb-8 relative z-10">
      <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
        {!qrTripId ? "Your plan is ready. Save it now." : "Trip Secured ✔"}
      </h3>
      <p className="text-sm sm:text-base text-gray-500 max-w-lg mx-auto">
        {!qrTripId
          ? "Save to access budget tracking, tickets & sharing."
          : "Your trip is safely stored in your dashboard."}
      </p>
    </div>

    {/* ================= BEFORE SAVE ================= */}
    {!qrTripId ? (
      <div className="space-y-4 max-w-sm mx-auto relative z-10">

        <button
          onClick={handleGenerateQR}
          disabled={!finalText || qrLoading}
          className="w-full bg-[#5b6f00] text-white py-4 rounded-2xl font-bold text-base hover:bg-[#4a5a00] hover:-translate-y-0.5 active:scale-[0.98] transition-all shadow-md shadow-[#5b6f00]/20 disabled:opacity-60 flex items-center justify-center gap-2.5 group"
        >
          {qrLoading ? (
            <>
              <div className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
              <span>Saving your trip...</span>
            </>
          ) : (
            <>
              <span>Save &amp; manage your trip</span>
              <span className="group-hover:translate-x-0.5 transition-transform border-l border-white/20 pl-2.5">→</span>
            </>
          )}
        </button>

        <p className="text-center text-xs text-gray-400 font-medium">
          🔒 Securely saved to your account
        </p>

      </div>
    ) : (

      /* ================= AFTER SAVE ================= */
      <div className="space-y-6 relative z-10">

        {/* ✅ SUCCESS */}
        <div className="bg-[#5b6f00]/6 border border-[#5b6f00]/20 rounded-xl p-5 text-center">
          <div className="w-10 h-10 bg-[#5b6f00]/15 text-[#5b6f00] rounded-full flex items-center justify-center mx-auto mb-2 text-xl font-bold">
            ✓
          </div>
          <p className="text-base font-bold text-[#5b6f00]">Trip Secured!</p>
          {/* <p className="text-sm text-[#5b6f00]/70 mt-1 font-medium">
            Scroll down to view your new travel dashboard.
          </p> */}
        </div>

        {/* 📲 SHARE SECTION */}
        <div className="bg-gray-50 border border-gray-100 p-5 rounded-2xl space-y-4 max-w-md mx-auto">

          <p className="text-sm font-bold text-gray-800 text-center">
            Invite friends to the trip
          </p>

          <a
            href={`https://wa.me/?text=${encodeURIComponent(
              `Check out my ${city} travel itinerary 🌍\n\n${window.location.origin}/share/${qrTripId}`
            )}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center justify-center w-full bg-[#25D366] text-white py-3.5 rounded-xl font-bold hover:bg-[#1ebd5a] active:scale-[0.98] transition shadow-sm"
          >
            Share on WhatsApp
          </a>

          <div className="flex gap-3">
            <button
              onClick={() => {
                navigator.clipboard.writeText(
                  `${window.location.origin}/share/${qrTripId}`
                );
              }}
              className="flex-1 flex items-center justify-center bg-white border border-gray-200 py-3 rounded-xl text-sm font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-300 active:scale-[0.98] transition"
            >
              🔗 Copy Link
            </button>

            <button
              onClick={async () => {
                if (navigator.share) {
                  await navigator.share({
                    title: `${city} Trip`,
                    url: `${window.location.origin}/share/${qrTripId}`,
                  });
                }
              }}
              className="flex-1 flex items-center justify-center bg-white border border-gray-200 py-3 rounded-xl text-sm font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-300 active:scale-[0.98] transition"
            >
              📤 More Options
            </button>
          </div>

        </div>

      </div>
    )}
  </div>

  {/* 🧠 DASHBOARD (MERGED HERE) */}
  {/* {qrTripId && (
    <div className="bg-white rounded-3xl p-6 sm:p-10 shadow-xl border border-gray-100 max-w-6xl mx-auto mt-16 animate-fade-in-up">

   
      <div className="text-center mb-12">
        <div className="inline-block px-4 py-1.5 bg-[#5b6f00]/10 text-[#5b6f00] text-xs font-bold uppercase tracking-widest rounded-full mb-4">
          Next Step
        </div>
        <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">
          Your Trip Dashboard 
        </h3>
        <p className="text-base text-gray-500 mt-3 max-w-xl mx-auto">
          Manage your bookings, add friends, and track your travel budget all in one place.
        </p>
      </div>

      <div className="w-full">
        <TripsDashboard
          compact
          highlightTrip={savedTripToken}
        />
      </div>

    </div>
  )} */}
</div>

      {/* ================= MAP & ATTRACTIONS ================= */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-14 sm:mt-20 space-y-12">

        {/* Map Section — collapsed by default, expandable */}
    {selectedPlace && (
  <div className="space-y-4">

    <div className="flex items-center justify-between">
      <div>
        <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-0.5">Explore</p>
        <h3 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">
          360° Street View
        </h3>
      </div>
    </div>

    {/* 🔽 PLACE SELECTOR */}
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      {places360.map((p, i) => (
        <button
          key={i}
          onClick={() => setSelectedPlace(p.place)}
          className={`px-3.5 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all ${
            selectedPlace === p.place
              ? "bg-[#5b6f00] text-white shadow-sm"
              : "bg-white border border-gray-200 text-gray-600 hover:border-gray-300"
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>

    {/* 🌍 360 STREET VIEW — reduced height, soft border */}
    <div className="h-[320px] sm:h-[420px] w-full rounded-2xl overflow-hidden border border-gray-100 shadow-sm">
      <iframe
  title="360-view"
  className="w-full h-full"
  loading="lazy"
  src={`https://www.google.com/maps?q=${encodeURIComponent(selectedPlace)}&layer=c&output=svembed`}
/>
    </div>

  </div>
)}

        {/* Attractions Section */}
        {osmData?.attractions?.length > 0 && (
          <div>
            {!osmError && <AttractionSection title={`Must-See in ${city}`} items={osmData.attractions} />}
          </div>
        )}

      </div>
        {showLoginPrompt && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white rounded-2xl p-7 w-full max-w-sm text-center space-y-5 shadow-2xl border border-gray-100">

              <div className="w-12 h-12 bg-gray-50 border border-gray-100 rounded-full flex items-center justify-center text-xl mx-auto">
                🔐
              </div>

              <div className="space-y-2">
                <h3 className="text-xl font-bold text-gray-900">Login required</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  To save and manage this itinerary, please sign in to your account.
                </p>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowLoginPrompt(false);
                    if (openLogin) openLogin();// or open your login modal
                  }}
                  className="flex-1 bg-[#5b6f00] text-white py-3 rounded-xl font-bold hover:bg-[#4a5a00] active:scale-[0.98] transition"
                >
                  Sign in
                </button>

                <button
                  onClick={() => {
                    setShowLoginPrompt(false);
                    setPendingQRSave(false);
                  }}
                  className="flex-1 py-3 rounded-xl font-semibold text-gray-600 hover:bg-gray-50 border border-gray-200 transition"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}


      {/* ================= MODAL: REORDER ================= */}
      {/* {showReorderModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl w-full max-w-2xl p-7 shadow-2xl border border-gray-100">
            <div className="space-y-1 mb-6">
              <h3 className="text-xl font-bold text-gray-900">Reorder Days</h3>
              <p className="text-sm text-gray-500">Drag cards to rearrange your itinerary</p>
            </div>

            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={({ active, over }) => {
                if (!over || active.id === over.id) return;
                setTempDays((items) => {
                  const oldIndex = items.findIndex((d) => d._id === active.id);
                  const newIndex = items.findIndex((d) => d._id === over.id);
                  const updated = [...items];
                  const [moved] = updated.splice(oldIndex, 1);
                  updated.splice(newIndex, 0, moved);
                  return updated;
                });
              }}
            >
              <SortableContext items={tempDays.map((day) => day._id)} strategy={rectSortingStrategy}>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
                  {tempDays.map((day) => (
                    <DraggableDayCard key={day._id} id={day._id} day={day} />
                  ))}
                </div>
              </SortableContext>
            </DndContext>

            <div className="flex justify-end gap-3 pt-2 border-t border-gray-50">
              <button
                onClick={() => setShowReorderModal(false)}
                className="px-6 py-2.5 rounded-xl text-sm text-gray-600 font-semibold hover:bg-gray-50 border border-gray-200 transition-colors"
              >
                Cancel
              </button>
              <button
                disabled={savingOrder}
                onClick={() => {
                  setSavingOrder(true);
                  setTimeout(() => {
                    setJsonData((prev) => ({
                      ...prev,
                      days: tempDays.map((day, index) => ({
                        ...day,
                        day: `DAY ${index + 1}`,
                        displayDay: index + 1,
                      })),
                    }));
                    setSavingOrder(false);
                    setShowReorderModal(false);
                  }, 2000);
                }}
                className="bg-[#5b6f00] text-white px-7 py-2.5 rounded-xl text-sm font-bold hover:bg-[#4a5a00] active:scale-[0.98] transition-all disabled:opacity-50 flex items-center gap-2"
              >
                {savingOrder && <div className="w-3.5 h-3.5 border-2 border-white/40 border-t-white rounded-full animate-spin" />}
                <span>Save Changes</span>
              </button>
            </div>
          </div>
        </div>
      )} */}

      {/* ================= YOUR SAVED TRIPS ================= */}

{/* {qrTripId && (
  <div
    id="saved-trips-section"
    className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-24"
  >

    <div className="text-center mb-12">
      <h2 className="text-3xl font-bold text-gray-900">
        Your Saved Trips
      </h2>

      <p className="text-gray-500 mt-2">
        This trip is now part of your travel collection.
      </p>
    </div>

   <TripsDashboard compact highlightTrip={savedTripToken} />

  </div>
)} */}

      {/* ================= STICKY CTA ================= */}
      {!qrTripId  && (
        <div className="fixed bottom-0 left-0 right-0 px-4 py-3 sm:px-6 sm:py-4 bg-white/95 backdrop-blur-xl border-t border-gray-100 z-[60] shadow-[0_-4px_24px_rgba(0,0,0,0.04)]">
          <div className="max-w-5xl mx-auto flex items-center justify-between gap-3">
            <div className="hidden sm:block">
              <p className="text-sm font-bold text-gray-900">Your plan is ready</p>
              <p className="text-xs text-gray-400 mt-0.5">Save it to unlock budget, tickets &amp; sharing</p>
            </div>
            <button
              onClick={() => document.getElementById("qr-section")?.scrollIntoView({ behavior: "smooth" })}
              className="w-full sm:w-auto bg-[#5b6f00] text-white px-6 py-3.5 rounded-xl font-bold text-sm hover:bg-[#4a5a00] hover:-translate-y-0.5 active:scale-[0.98] hover:shadow-lg hover:shadow-[#5b6f00]/20 transition-all flex items-center justify-center gap-2 group"
            >
              Save your trip
              <span className="group-hover:translate-x-0.5 transition-transform border-l border-white/20 pl-2">→</span>
            </button>
          </div>
        </div>
      )}

      {/* {showSaveReminder && !qrTripId && (
  <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl text-center space-y-6 animate-fade-in">

      <h3 className="text-xl font-bold text-gray-900">
        ⚠️ Your trip will be lost if you leave this page
      </h3>

      <p className="text-sm text-gray-600">
        Save your itinerary now so you can share it or revisit it anytime.
      </p>

      <div className="flex gap-3 justify-center">

        <button
          onClick={() => {
            setShowSaveReminder(false);
            document
              .getElementById("qr-section")
              ?.scrollIntoView({ behavior: "smooth" });
          }}
          className="px-6 py-3 rounded-xl bg-[#5b7c67] text-white font-semibold hover:bg-[#4a6a58] transition"
        >
          Save Now
        </button>

        <button
          onClick={() => setShowSaveReminder(false)}
          className="px-6 py-3 rounded-xl bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition"
        >
          Lose My Trip
        </button>

      </div>
    </div>
  </div>
)} */}

{isRedirecting && (
  <div className="fixed inset-0 bg-black/30 backdrop-blur-md flex flex-col items-center justify-center z-[999]">

    {/* Loader */}
    <MiniLoader size={28} />

    {/* Text */}
    <p className="mt-4 text-sm font-semibold text-gray-800">
      Opening your dashboard...
    </p>

  </div>
)}

<ReorderModal
  open={showReorderModal}
  onClose={() => setShowReorderModal(false)}
  items={tempDays}
  setItems={setTempDays}
  saving={savingOrder}
  onSave={() => {
    setSavingOrder(true);

    setTimeout(() => {
      setJsonData((prev) => ({
        ...prev,
        days: tempDays.map((day, index) => ({
          ...day,
          day: `DAY ${index + 1}`,
          displayDay: index + 1,
        })),
      }));

      setSavingOrder(false);
      setShowReorderModal(false);
    }, 500);
  }}
/>


    </div>
  );

};

export default TripResults;
